import { constants } from '@mapbox/mapbox-gl-draw';

type ExtendedDrawModes = MapboxDraw.DrawModes & {
  PASSING_DRAW_MODE: string;
  PASSING_DRAW_LINE_STRING_MODE: string;
  CUT_POLYGON_MODE: string;
  SPLIT_POLYGON_MODE: string;
};

export const constantsModes: ExtendedDrawModes = {
  ...constants.modes,
  PASSING_DRAW_MODE: 'passing_draw_polygon',
  PASSING_DRAW_LINE_STRING_MODE: 'passing_draw_line_string',
  CUT_POLYGON_MODE: 'cut_polygon',
  SPLIT_POLYGON_MODE: 'split_polygon',
};

export const highlightPropertyName = `highlight`;

export type CustomDrawMode =
  | MapboxDraw.DrawMode
  | 'passing_draw_polygon'
  | 'passing_draw_line_string'
  | 'cut_polygon'
  | 'split_polygon';
